export class PrizeList{
    public name: string;
    public description: string;
    public value: number;
    public expenseCost: number;
}